import React, { FC } from 'react';
import styled from 'styled-components';
import { Columns, Column } from '../../base/grid';
import ArticleBoxCubeLoader from '../articleBoxCube/articleBoxCubeLoader/articleBoxCubeLoader';
import { fadeIn } from '../../../constants/keyframes/fades';

interface Props {}

const StyledLoader = styled.div`
	opacity: 0;
	animation: ${fadeIn} 300ms linear forwards;
	animation-delay: 300ms;
`;

const ArticleListLoader: FC<Props> = () => {
	return (
		<StyledLoader>
			<Columns>
				<Column tablet={1 / 2} desktopSmall={1 / 3}>
					<ArticleBoxCubeLoader />
				</Column>
				<Column tablet={1 / 2} desktopSmall={1 / 3}>
					<ArticleBoxCubeLoader />
				</Column>
				<Column tablet={1 / 2} desktopSmall={1 / 3}>
					<ArticleBoxCubeLoader />
				</Column>
			</Columns>
		</StyledLoader>
	);
};

export default ArticleListLoader;
